var _rect, _rect2, _path, _rect3, _rect4, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29.1284,
    y: 36.1986,
    width: 9.69281,
    height: 16.1096,
    fill: "#606060"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.824,
    y: 17.4902,
    width: 39.7915,
    height: 26.503,
    rx: 6.16563,
    fill: "#2B2B2B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.824 38.796H53.6155C53.6155 41.6661 51.2889 43.9927 48.4188 43.9927H19.0206C16.1506 43.9927 13.824 41.6661 13.824 38.796Z",
    fill: "#909090"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5383,
    y: 48.151,
    width: 18.8755,
    height: 4.15733,
    rx: 2.07866,
    fill: "#BEBEBE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1937_18902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 17,
    width: 41,
    height: 27
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.824,
    y: 17.4902,
    width: 39.7915,
    height: 26.503,
    rx: 6.16563,
    fill: "#212121"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1937_18902)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1937_18902",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 9,
    width: 47,
    height: 38
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.821 9.69458H56.7174L78.2242 46.5908H54.3278L32.821 9.69458Z",
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1937_18902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0063,
    y: 17.4905,
    width: 39.7915,
    height: 26.503,
    rx: 6.06455,
    fill: "url(#paint0_linear_1937_18902)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1937_18902",
    x1: 33.9021,
    y1: 17.4905,
    x2: 33.9021,
    y2: 43.9935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgComputer);
export default __webpack_public_path__ + "static/media/img_computer.2cb4c13502371e2f14395f61d83c9c7b.svg";
export { ForwardRef as ReactComponent };